import { defineStore } from 'pinia'
import httpService from '@/utils/httpService'
import { URL } from '@/constants/urls'

export const useUserStore = defineStore('user', {
  state: () => ({
  }),

  actions:{
    async login(form){
      sessionStorage.clear();
      const res = await httpService.post(URL.LOGIN, form)
      sessionStorage.setItem('tenantName', res.tenantName);
      sessionStorage.setItem('token', res.token);
      sessionStorage.setItem('userName', res.userInfo.userName);
      sessionStorage.setItem('permission', res.userInfo.permission);
    },

    async logout(){
      await httpService.post(URL.LOGOUT, {})
      sessionStorage.clear();
    }
  }
})